import axios from "axios";
import apiEndpoints from "configs/apiEndPoints";
import Cookies from "universal-cookie";
import { create } from "zustand";
import { useTokenStore } from "./useTokenStore";
import { addDays } from "date-fns";

const cookies = new Cookies();

const fetchProfile = async (accessToken: string) => {
  try {
    const response = await axios.get(apiEndpoints.host + apiEndpoints.profile, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    return response.data.data;
  } catch (error) {
    console.error("Failed to fetch profile:", error);
    throw error;
  }
};

interface AuthState {
  isAuthenticated: boolean;
  userEmail: string | null;
  profile: any | null;
  isFetching: boolean;
  login: (email: string, password: string) => Promise<void>;
  logout: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  isAuthenticated: cookies.get("isAuthenticated") || false,
  userEmail: cookies.get("userEmail") || null,
  isFetching: false,
  profile: cookies.get("userProfile") || null,
  login: async (email: string, password: string) => {
    set({ isFetching: true });
    try {
      const response = await axios.post(apiEndpoints.host + apiEndpoints.login, {
        email,
        password,
      });
      const { accessToken, refreshToken } = response.data;
      // cookies.set("accessToken", accessToken, { path: "/" });
      // cookies.set("refreshToken", refreshToken, { path: "/" });
      // cookies.set("isAuthenticated", true, { path: "/" });
      // cookies.set("userEmail", email, { path: "/" });
      const expiresIn7Days = addDays(new Date(), 7);
      cookies.set("accessToken", accessToken, { path: "/", expires: expiresIn7Days });
      cookies.set("refreshToken", refreshToken, { path: "/", expires: expiresIn7Days });
      cookies.set("isAuthenticated", true, { path: "/", expires: expiresIn7Days });
      cookies.set("userEmail", email, { path: "/", expires: expiresIn7Days });
      set({
        isAuthenticated: true,
        userEmail: email,
        isFetching: false,
      });
      useTokenStore.getState().setTokens(accessToken, refreshToken);
      // Fetch profile data
      const profileData = await fetchProfile(accessToken);
      cookies.set("userProfile", profileData, { path: "/", expires: expiresIn7Days });

      set({ profile: profileData });
    } catch (error) {
      set({ isFetching: false });
      console.error("Login failed:", error);
    }
  },
  logout: () => {
    cookies.remove("accessToken", { path: "/" });
    cookies.remove("refreshToken", { path: "/" });
    cookies.remove("isAuthenticated", { path: "/" });
    cookies.remove("userEmail", { path: "/" });
    set({
      isAuthenticated: false,
      userEmail: null,
      isFetching: false,
    });
    useTokenStore.getState().removeTokens();
  },
}));
